import { useMutation, useLazyQuery, useQuery } from '@apollo/react-hooks'
import gql from 'graphql-tag'

const GET_SESSION = gql`
  query {
    session {
      user {
        id
        username
        isGuest
      }
    }
  }
`

export const useGetSession = (options) =>
  useQuery(GET_SESSION, { ...options, fetchPolicy: 'network-only' })

const CREATE_SESSION = gql`
  mutation createSession($email: String!, $password: String!) {
    newSession: createSession(email: $email, password: $password) {
      ... on Session {
        user {
          id
          firstname
          username
          isGuest
          email
        }
      }
      ... on UserInputError {
        error {
          key
          fields
          message
          data
        }
      }
    }
  }
`
export const useCreateSession = (options) =>
  useMutation(CREATE_SESSION, options)

const CREATE_GUEST_SESSION = gql`
  mutation createGuestSession($firstname: String!) {
    createdGuestSession: createGuestSession(firstname: $firstname) {
      ... on Session {
        user {
          id
          username
          createdAt
          isGuest
          deleted
        }
      }
      ... on UserInputError {
        error {
          message
          key
          fields
        }
      }
    }
  }
`

export const useCreateGuestSession = (options) =>
  useMutation(CREATE_GUEST_SESSION, options)

const DELETE_SESSION = gql`
  mutation {
    deleteSession
  }
`
export const useDeleteSession = () => useMutation(DELETE_SESSION)

const REQUEST_MAGIC_LINK = gql`
  mutation requestMagicLink($email: String!) {
    requestMagicLink(email: $email)
  }
`
export const useRequestMagicLink = () => useMutation(REQUEST_MAGIC_LINK)

const CHECK_MAGIC_LINK = gql`
  mutation checkMagicLink($hash: String!) {
    checkMagicLink(hash: $hash)
  }
`
export const useCheckMagicLink = (variables) =>
  useMutation(CHECK_MAGIC_LINK, { variables })

const CONSUME_MAGIC_LINK = gql`
  mutation consumeMagicLink($hash: String!) {
    consumeMagicLink(hash: $hash) {
      ... on Session {
        user {
          id
          firstname
          email
          username
        }
      }
      ... on UserInputError {
        error {
          message
          key
          fields
        }
      }
    }
  }
`
export const useConsumeMagicLink = (variables) =>
  useMutation(CONSUME_MAGIC_LINK, { variables })

const SESSION_QUERY = gql`
  query {
    session {
      user {
        id
        firstname
        username
        email
      }
    }
  }
`
export const useLazySessionQuery = () =>
  useLazyQuery(SESSION_QUERY, { fetchPolicy: 'network-only' })
